// extracted by mini-css-extract-plugin
module.exports = {"info":"ThemeManual_info__7yOVQ"};